import React from "react"
import {useTranslation} from "react-i18next"

import {usePersonGroups as useItems} from "../../contexts/PersonGroupContext"

import ItemList from '../../components/PersonGroups/List'
import PageList from '../common/List'

const PagePersonGroupsList: React.FC = () => {

    const { t } = useTranslation()

    const { fetchItems } = useItems()

    const
        itemType: string     = 'PersonGroup',
        itemTypeName: string = t('person-groups.title_list'),
        itemTypeUrl: string  = 'person-groups'

    return (
        <PageList
            ItemList={ItemList}
            itemType={itemType}
            itemTypeName={itemTypeName}
            itemTypeUrl={itemTypeUrl}
            showAddButton={false}
            fetchItems={fetchItems}
            useItems={useItems}
        />
    )
}

export default PagePersonGroupsList